import React, { useState, useEffect, useRef } from "react";
import Hammer from "hammerjs";
import RugTemplate from "../rug/rugTemplates/rug";

export default function RoomRugCarpetItem({
  rug,
  rugKey,
  activeHandler,
  disableScroll,
  enableScroll,
}) {
  const [width, setWidth] = useState(100);
  const [height, setHeight] = useState(100);
  const elemRef = useRef();

  useEffect(() => {
    const setPinch = (hammer) => {
      hammer.on("pinch", (e) => {
        setHeight(height * e.scale);
        setWidth(width * e.scale);
      });
    };
    const hammertime = new Hammer(elemRef.current);
    hammertime.get("pinch").set({
      enable: true,
      threshold: 0.02,
    });
    setPinch(hammertime);
    return () => {
      hammertime.off("pinch");
    };
    // we don't want a re-render on height and width change
    // hammer will handle it
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const wheelHandler = (e) => {
    if (e.deltaY < 0) {
      setHeight(height + 2);
      setWidth(width + 2);
    } else {
      setHeight(height - 2);
      setWidth(width - 2);
    }
  };

  return (
    <div
      className=""
      ref={elemRef}
      onWheel={wheelHandler}
      onMouseEnter={disableScroll}
      onMouseLeave={enableScroll}
      onClick={() => activeHandler(rugKey)}
      style={{
        width: width + "%",
        height: height + "%",
        position: "absolute",
      }}
    >
      <RugTemplate show={true} rug={rug.rug} />
    </div>
  );
}
